import Vue from 'vue'
import App from './App.vue'
import store from './store/index'

import Element from 'element-ui'
import remConfig from './js/remConfig.js'
import {
	adminMenu
} from '@/js/axios' // 获取权限路由
import {
	Base64
} from 'js-base64'

import router, {
	defaultRoutes,
	routes as routers
} from '@/router'


Vue.use(Element);


Vue.config.productionTip = false;
// // rem适应
// remConfig();
// window.addEventListener('resize',remConfig);


// 按需引入element
import 'element-ui/lib/theme-chalk/index.css';
import {
	Button,
	Input,
	InputNumber,
	Form,
	FormItem,
	Checkbox,
	CheckboxGroup,
	Dialog,
	Container,
	Main,
	Aside,
	Header,
	Menu,
	Message,
	Submenu,
	MenuItem,
	Select,
	Option,
	DatePicker,
	Radio,
	RadioGroup,
	Table,
	TableColumn,
	Dropdown,
	DropdownMenu,
	DropdownItem,
	Pagination,
	Tree,
	MessageBox,
	Row,
	Col,
	Tooltip,
	Image,
	Switch,
	Steps,
	Step,
	Tag,
	Tabs,
	TabPane,
	Autocomplete,
	Collapse,
	CollapseItem,
	Popover,
	Upload
} from 'element-ui';

Vue.use(Button)
	.use(Input)
	.use(Form)
	.use(FormItem)
	.use(Checkbox)
	.use(Dialog)
	.use(Container)
	.use(Main)
	.use(Aside)
	.use(Header)
	.use(Menu)
	.use(Submenu)
	.use(MenuItem)
	.use(Select)
	.use(Option)
	.use(DatePicker)
	.use(CheckboxGroup)
	.use(Radio)
	.use(RadioGroup)
	.use(Table)
	.use(TableColumn)
	.use(Dropdown)
	.use(DropdownMenu)
	.use(DropdownItem)
	.use(Pagination)
	.use(Tree)
	.use(Tooltip)
	.use(Image)
	.use(Upload)
	.use(Switch)
	.use(InputNumber)
	.use(Steps)
	.use(Step)
	.use(Tag)
	.use(Tabs)
	.use(TabPane)
	.use(Autocomplete)
	.use(Collapse)
	.use(CollapseItem)
	.use(Popover)
	.use(Row)
	.use(Col);

import '@/styles/setElementUi.css' // 修改element默认样式
import '@/styles/public_qjc.css' // 自定义通用css

import myAlert from '@/components/Alert/index.js'
Vue.prototype.$myAlert = myAlert;

import myAlert2 from '@/components/Alert2'
Vue.prototype.$myAlert2 = myAlert2;

Vue.prototype.$confirm = MessageBox.confirm;

Vue.prototype.$message = Message


router.beforeEach((to, from, next) => {
	if (store.state.isLogin) {
		if (store.state.menus.length > 0) {
			next();
		} else {
			const data = {
				act: "menu"
			}
			adminMenu(data).then(res => {
				if (res.code == 200) {
					const list = JSON.parse(Base64.decode(res.data))

					store.commit('addMenus', JSON.parse(JSON.stringify(list)));
					let routersList = []; // 路由列表
					let parentRouter = defaultRoutes;
					let routesFlated = []
					let fullpathRoutes = []

					const flatRoutes = (list, parentPath = "") => {
						return list.reduce((arr, item) => {
							item.fullpath = ((item.path && parentPath) ? `${parentPath}/` :
								parentPath) + item.path
							item.parentPath = parentPath
							if (item.children) {
								routesFlated.push(item)
								return [...arr, item, ...flatRoutes(item.children, item
									.fullpath)]
							}
							routesFlated.push(item)
							return [...arr, item]
						}, [])
					}

					fullpathRoutes = flatRoutes(routers)
					const addMenus = list => {
						for (var i = 0; i < list.length; i++) {
							// 在已有路由中查找相关路由
							var rt = fullpathRoutes.filter(r => r.fullpath == list[i].url)[0];
							// 是否存在相关路由
							if (rt && rt.about) {
								routersList = routersList.concat(rt.about);
								delete rt.about;
							}

							if (/^\//.test(list[i].url)) { // 非右侧内容路由(无左侧菜单,即 非admin路由/下children子路由)
								if (rt) {
									routersList.push(rt);
								}

							} else if (list[i].url) { // 右侧内容路由(包含左侧菜单,即admin路由/下children子路由)
								if (rt) {
									parentRouter.children.push(rt);
								}
							}

							// 子路由
							if (list[i].son && list[i].son.length > 0) {
								addMenus(list[i].son);
							}

						}
					}

					addMenus(list);
					const arr = parentRouter.map(item => {
						const arr = routersList.filter(cItem => cItem.parentPath == item.path)
						item.children = arr
						return item
					})
					router.addRoutes(arr);
					
					const toPath =  sessionStorage.getItem("historyRoute")
					
					next(toPath || "/menu");

				} else {
					alert(res.msg);
					next();
				}
			})
		}

	} else {
		store.commit('addMenus', []);
		if (to.meta.isLogin) {
			next({
				path: '/',
				// query: {
				// 	toUrl: to.fullPath // 保存用户打算进入页面，登录后直接进入
				// }
			});
		} else {
			next();
		}
	}
});


const _vm = new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app');


window._vm = _vm